import { CircularProgress, Fade } from '@mui/material';
import Box from '@mui/material/Box';

interface LoadingOverlayProps {
  loading: boolean;
  zIndex?: number;
  progressSize?: number | string;
}
const LoadingOverlay = ({
  loading,
  zIndex = 100,
  progressSize = 40
}: LoadingOverlayProps) => {
  return (
    <>
      {loading ? (
        <Fade in={loading} timeout={350}>
          <Box
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            position="absolute"
            top="0"
            left="0"
            bgcolor="rgba(0, 0, 0, 0.1)"
            zIndex={zIndex}
          >
            <CircularProgress size={progressSize} />
          </Box>
        </Fade>
      ) : null}
    </>
  );
};

export default LoadingOverlay;
